import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, onSnapshot } from "firebase/firestore";
import { cardStyle, btnStyle, btnSecondaryStyle, colors } from "./lib/theme";
import logo from "./assets/logo.png";
import photoGarboldisham from "./assets/venue-garboldisham.jpeg";
import photoBardwell from "./assets/venue-bardwell.jpeg";
import photoBanham from "./assets/venue-banham.jpeg";
import photoRickinghall from "./assets/venue-rickinghall.jpeg";

var GALLERY = [
  { src: photoRickinghall, caption: "Rickinghall" },
  { src: photoBanham, caption: "Banham" },
  { src: photoGarboldisham, caption: "Garboldisham" },
  { src: photoBardwell, caption: "Bardwell" },
];

export default function HomePage({ onJoin, onLogIn, onContact }) {
  var [venues, setVenues] = useState([]);
  var [templates, setTemplates] = useState([]);

  useEffect(function () {
    var unsubVenues = onSnapshot(collection(db, "venues"), function (snap) {
      setVenues(snap.docs.map(function (d) { return { id: d.id, ...d.data() }; }));
    });
    var unsubTpl = onSnapshot(collection(db, "sessionTemplates"), function (snap) {
      setTemplates(snap.docs.map(function (d) { return { id: d.id, ...d.data() }; }).filter(function (t) { return t.active; }));
    });
    return function () { unsubVenues(); unsubTpl(); };
  }, []);

  var activeVenueIds = new Set(templates.map(function (t) { return t.venueId; }));
  var activeVenues = venues.filter(function (v) { return activeVenueIds.has(v.id); });
  var totalCourts = activeVenues.reduce(function (sum, v) { return sum + (v.courtCount || 1); }, 0);
  var stats = [
    { n: String(activeVenues.length), label: "venues" },
    { n: String(templates.length), label: "sessions a week" },
    { n: String(totalCourts), label: "courts across the region" },
  ];

  return (
    <div>
      <div style={{ textAlign: "center", padding: "24px 12px 32px" }}>
        <img src={logo} alt="East Anglia Pickleball" style={{ maxWidth: 320, width: "100%", marginBottom: 18 }} />
        <p style={{ fontSize: 15, color: colors.textDim, maxWidth: 440, margin: "0 auto 22px", lineHeight: 1.5 }}>
          Friendly pickleball sessions across East Anglia, every week — all standards,
          beginners always welcome.
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={onJoin} style={{ ...btnStyle, width: "auto", padding: "12px 24px" }}>
            View Sessions
          </button>
          <button onClick={onLogIn} style={{ ...btnSecondaryStyle, width: "auto", padding: "12px 24px" }}>
            Member Log In
          </button>
        </div>
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 24, flexWrap: "wrap" }}>
        {stats.map(function (stat) {
          return (
            <div key={stat.label} style={{ ...cardStyle, flex: "1 1 120px", textAlign: "center", padding: "18px 10px" }}>
              <div style={{ fontSize: 26, fontWeight: 800, color: colors.teal }}>{stat.n}</div>
              <div style={{ fontSize: 12, color: colors.textDim }}>{stat.label}</div>
            </div>
          );
        })}
      </div>

      <h3 style={{ fontSize: 15, marginBottom: 12, color: colors.text }}>Out on Court</h3>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 24 }}>
        {GALLERY.map(function (g) {
          return (
            <div key={g.caption} style={{ position: "relative", borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 3px rgba(22,155,182,0.15)" }}>
              <img src={g.src} alt={g.caption} style={{ width: "100%", height: 130, objectFit: "cover", display: "block" }} />
            </div>
          );
        })}
      </div>

      <div style={{ ...cardStyle, marginBottom: 24, background: colors.tealTint, border: "1px solid " + colors.borderStrong }}>
        <h3 style={{ marginTop: 0, fontSize: 15, color: colors.text }}>New to Pickleball?</h3>
        <p style={{ fontSize: 13, color: colors.textDim, margin: 0 }}>
          Every one of our sessions is beginner friendly — just turn up, borrow a paddle,
          and someone will show you the ropes. Check the <strong>Sessions</strong> tab for what's
          on near you this week.
        </p>
      </div>

      <div style={{ ...cardStyle, textAlign: "center" }}>
        <h3 style={{ marginTop: 0, fontSize: 15 }}>Got a Question?</h3>
        <p style={{ fontSize: 13, color: colors.textDim, marginBottom: 16 }}>
          Get in touch and we'll get back to you as soon as possible.
        </p>
        <button onClick={onContact} style={{ ...btnSecondaryStyle, width: "auto", padding: "10px 20px" }}>
          Get in Touch
        </button>
      </div>
    </div>
  );
}
